import { ConfigProviderToken } from "@thepiquelab/archus-components-web";
import { OAuthPermission } from "@thepiquelab/web-types";
import { lazy, memo } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import BaseLayout from "./Layout/BaseLayout";
import SpecialLayout from "./Layout/SpecialLayout";
import { IsPoweredByQianKun } from "./config";
import { useAccessControl } from "./hooks/useAccessControl";

const InsufficientCredentialsPage = lazy(
  () => import("./pages/Errors/InsufficientCredentialsPage"),
);

function App() {
  const { hasAllPermissions } = useAccessControl();

  if (IsPoweredByQianKun) {
    return <SpecialLayout />;
  }

  return (
    <ConfigProviderToken components={{}}>
      {hasAllPermissions([OAuthPermission.ARCHUS_ADMINISTRATION_ACCESS]) ? (
        <BaseLayout />
      ) : (
        <Routes>
          <Route path="*" element={<Navigate to="/error" />} />
          <Route
            index
            path="/error"
            element={<InsufficientCredentialsPage />}
          />
        </Routes>
      )}
    </ConfigProviderToken>
  );
}

export default memo(App);
